import React from 'react'
import DatePicker from "react-datepicker"
import { Field } from 'react-final-form'
import { useTheme } from 'react-jss'

import styles from 'components/form/form-style'
import classNames from 'classnames'
import { isInputWithError } from 'helpers/form'

export default function DatePickerInput({ placeholder, name, datePickerProps }) {
  const theme = useTheme()
  const classes = styles(theme)

  const inputClassNames = meta => classNames(
    classes.datePickerInput,
    { [classes.inputWithError]: isInputWithError(meta) },
    { [classes.focusedInput]: meta.active },
  )

  return (
    <Field name={name} >
      {({ input, meta }) => (
          <DatePicker
            {...datePickerProps}
            placeholderText={placeholder}
            dateFormat="P"
            selected={input.value}
            name={name}
            className={inputClassNames(meta)}
            onChange={(date) => {
              input.onChange(date);
            }}
          />
      )}
    </Field>
  )
}
